<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/bulks/invoices" exact>Todos los procesos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/bulks/invoices?status=pending" exact>Pendiente</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/bulks/invoices?status=processing" exact>Procesando</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/bulks/invoices?status=finalized" exact>Finalizado</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.bulks.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Facturación masiva</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="invoices" class="mr-1" />
              <v-btn outlined color="secondary" @click="dialogCreate=true"><v-icon left small>mdi-plus</v-icon> Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-skeleton-loader v-if="$store.state.bulks.retrieveLoader" transition="fade-transition" type="table" />
          <template v-else>
            <v-col v-if="!invoicesList.length" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
              <span class="d-block subtitle-1">No existen procesos</span>
              <v-btn class="my-5" @click="dialogCreate=true" outlined>Crear facturación masiva</v-btn>
            </v-col>
            <template v-else>
              <v-data-table :headers="headers" :items="invoicesList" :items-per-page="pagination" mobile-breakpoint hide-default-footer hide-default-header disable-sort @click:row="(instance) => $router.push({name: 'InvoiceBulkRetrieve', params: {id: instance.id}})" style="cursor: pointer">
                <!-- header -->
                <template v-slot:[`header`]="{ props: { headers } }">
                  <VTableHeaders :headers="headers" @sort="setSort" />
                </template>
                <!-- end header -->
                <template v-slot:[`item.id`]="{ item }">
                  <code class="body-2 text--secondary">{{item.id}}</code>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div class="text-right" v-if="showStatus">
                    <v-chip v-if="item.status === 'pending'" class="mx-1" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
                    <v-chip v-else-if="item.status === 'processing'"  class="mx-1" color="defaultGrey" text-color="secondary" small>Procesando</v-chip>
                    <v-chip v-else-if="item.status === 'finalized'" class="mx-1" color="defaultGrey" text-color="secondary" small>Finalizado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                    <v-chip v-else-if="item.status === 'failed'" class="mx-1" color="defaultGrey" text-color="secondary" small>Fallido<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                  </div>
                </template>
                <template v-slot:[`item.invoices`]="{ item }">
                  <div class="text-right">
                    <span class="text--secondary font-weight-medium">{{item.invoices.length}}</span>
                  </div>
                </template>
                <template v-slot:[`item.created`]="{ item }">
                  <span>{{item.created | date}}</span>
                </template>
              </v-data-table>
              <template v-if="showPagination || showAll">
                <v-divider />
                <v-row class="mx-0" align="center">
                  <template v-if="showPagination">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                    </v-col>
                  </template>
                </v-row>
              </template>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog create -->
    <v-dialog v-model="dialogCreate" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear facturación masiva</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon :ripple="false" small @click="dialogCreate=false"><v-icon small>mdi-close</v-icon></v-btn>
              </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-2">
              <v-list-item-title>Fuente de datos</v-list-item-title>
              <v-list-item-subtitle>
                <v-file-input v-model="file" :error="$v.newBulk.file.$error" type="file" accept=".csv,.xlsx,.json" prepend="mdi-paper-clip" hide-details  background-color="transparent" placeholder="No se eligió ningún archivo" solo flat chips />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Formato</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="4">
                  <v-select v-model="$v.newBulk.import_format.$model" :error="$v.newBulk.import_format.$error"   :items="importFormats" item-text="importFormats" item-value="importFormats" hide-details single-line dense height="30" outlined background-color="white" />
                </v-col>
              </v-list-item-subtitle>
              </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Generar sólo borradores</v-list-item-title>
              <v-list-item-subtitle absolute>
                <v-switch class="mt-n4" v-model="newBulk.only_draft" style="position:absolute" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Enviar vía email al cliente</v-list-item-title>
              <v-list-item-subtitle>
                <v-switch class="mt-n4" v-model="newBulk.send_email" :disabled="newBulk.only_draft" style="position:absolute" />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreate=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createInvoiceBulk" :loading="$store.state.bulks.createLoader" color="primary">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create -->

    <v-overlay :value="$store.state.bulks.createLoader" opacity="0.85" z-index="300">
      <div class="d-flex flex-column align-center text-center px-6">
        <v-progress-circular class="mb-4" size="56" width="5" color="primary" indeterminate />
        <span class="subtitle-1 font-weight-medium white--text">Estamos inicializando el proceso de facturación</span>
        <span class="body-2 mt-2 white--text">Este proceso puede demorar un par de minutos. No cierres ni recargues esta página.</span>
      </div>
    </v-overlay>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VQueryBuilder,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    file: null,
    newBulk: {
      file: null,
      import_format: '',
      send_email: false,
      only_draft: false
    },
    importFormats: ['csv', 'xlsx', 'json'],
    filters: [
      {
        type: 'text',
        id: 'invoices__customer',
        label: 'Cliente',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'date',
        label: 'Fecha de creación',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ],
    headers: [
      { text: 'ID', value: 'id', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'status', sortable: false },
      { text: 'Documentos', value: 'invoices', align: 'end', sortable: false },
      { text: 'Creado', value: 'created', align: 'end', sortable: true }
    ],
    dialogCreate: false
  }),
  computed: mapState({
    count: state => state.bulks.invoicesCount,
    invoicesList: state => state.bulks.invoicesList
  }),
  watch: {
    'newBulk.only_draft' () {
      if (this.newBulk.only_draft) {
        this.newBulk.send_email = false
      }
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('bulks/LIST', {
        resource: 'bulks/invoices',
        query: this.$route.query
      })
    },
    createInvoiceBulk () {
      this.newBulk.file = this.file
      this.$v.newBulk.$touch()
      if (this.$v.newBulk.$invalid) {
        return false
      }
      const payload = new FormData()
      payload.append('file', this.newBulk.file, this.newBulk.file.name)
      payload.append('import_format', this.newBulk.import_format)
      payload.append('send_email', this.newBulk.send_email)
      payload.append('only_draft', this.newBulk.only_draft)
      this.$store.dispatch('bulks/CREATE', {
        resource: 'bulks/invoices',
        payload: payload,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        this.$router.push({name: 'InvoiceBulkRetrieve', params: {id: response.data.id}})
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newBulk: {
      file: {
        required
      },
      import_format: {
        required
      }
    }
  }
}
</script>
